export const painPoints = [
  {
    emoji: '🧭',
    title: "You don't know where to start",
    desc: 'The Korean alphabet looks impossible and you are overwhelmed by where to begin. This method organizes everything: first the basics, then the practical, then the conversational.',
  },
  {
    emoji: '🔤',
    title: 'You get stuck with Hangul (and it all sounds the same)',
    desc: 'You learn it here the guided way, so you recognize patterns and pronounce with intention. No more confusion between similar letters and sounds.',
  },
  {
    emoji: '🧩',
    title: "You know random words but can't form sentences",
    desc: 'You learn the basic sentence structure to build phrases that actually make sense and start communicating from day one.',
  },
  {
    emoji: '💭',
    title: 'You study but forget quickly',
    desc: 'You get concrete memorization tips and retention routines so what you study actually sticks in your brain instead of fading in a week.',
  },
  {
    emoji: '🎬',
    title: 'You watch K-Dramas and understand nothing',
    desc: 'Subtitles do all the work and you never catch a single real word. Here you train your ear with the expressions that actually appear on screen.',
  },
  {
    emoji: '🔁',
    title: 'You started an app and quit after two weeks',
    desc: 'Streaks are not progress. A daily 30-day plan with visible milestones is what keeps you going until you hold your first real conversation.',
  },
];
